export default __webpack_public_path__ + "static/media/eigenheim_icons_present.2bbc3a47.svg";